import {
  BrandCompany,
  BrandLanding,
  BrandLegal,
  BrandHubspot,
  BrandImages,
  BrandMeta,
  BrandTitles,
} from "types/appBranding";

export const Images: BrandImages = {
  logo: {
    src: "/assets/mti/logo-mti-ici.png",
    alt: "Mission Trip Insurance — A Service of ICI Traveler",
    width: 70,
    height: 72,
  },
  adminLogo: {
    src: "/assets/mti/logo-mti-ici.png",
    alt: "Mission Trip Insurance — A Service of ICI Traveler",
    width: 62,
    height: 64,
  },
  heroLogo: {
    src: "/assets/shared/logo-trip-armor-black.png",
    alt: "TripArmor Travel Protection Plan",
    width: 260,
    height: 60,
  },
  favicon: "/favicon.ico",
  hero_bcg: "/assets/mti/hero-mti-mission.jpg",
  hero_bcg_size: "cover",
  hero_bcg_position: "center 42%",
};

export const Company: BrandCompany = {
  name: "ICI Traveler",
  city: "Oklahoma",
  website: "https://www.insuranceconsultantsintl.com",
  note: "Mission Trip Insurance is a division of ICI Traveler, formerly Insurance Consultants International.",
};

//by component name
export const Titles: BrandTitles = {
  index: "Mission Trip Insurance",
  purchase: "Mission Trip Insurance",
  admin_index: "Dashboard | Mission Trip Insurance",
  admin_insureds: "Insureds | Mission Trip Insurance Admin Portal",
  admin_purchases: "Purchases | Mission Trip Insurance Admin Portal",
  admin_quote_requests: "Quote Requests | Mission Trip Insurance Admin Portal",
};

//have doubts regarding this one
export const Meta: BrandMeta = {
  index: {
    name: "description",
    content:
      "Choose the protection that fits your trip with Mission Trip Insurance. Review options for Post-Departure, Trip Cancellation, and Cancel for Any Reason coverage.",
  },
  purchase: {
    name: "description",
    content:
      "Choose the protection that fits your trip with Mission Trip Insurance. Review options for Post-Departure, Trip Cancellation, and Cancel for Any Reason coverage.",
  },
};

export const Hubspot: BrandHubspot = {
  dealStages: {
    initialized: "appointmentscheduled",
    completed: "closedwon",
  },
};

export const Landing: BrandLanding = {
  heroCta: "See My Options",
  coverageOptions: {
    heading: "Your Coverage Options",
    items: [
      {
        title: "Post-Departure Coverage",
        text: "Protection for unexpected situations after your trip begins, including eligible medical expenses, emergency medical evacuation, travel delays, baggage issues, and other covered events.",
        note: "Recommended for every traveler.",
      },
      {
        title: "Basic Trip Cancellation",
        text: "Adds protection for certain covered reasons that may cause you to cancel your trip before departure, along with the benefits included in Post-Departure Coverage.",
      },
      {
        title: "Cancel for Any Reason",
        text: "Provides additional cancellation flexibility when available. Eligibility and purchase deadlines apply, so it is important to enroll soon after making your initial trip payment.",
      },
    ],
    footnote:
      "Coverage options and availability may vary based on your residence, destination, trip dates, trip cost, and the date of your initial trip payment.",
  },
};

export const Legal: BrandLegal = {
  termsEntryId: "5lHQEq6kTDunyRBLB95dmW",
  privacyEntryId: "1CKYkveYORD5qGhFwHnmkt",
};
